import { defineMessages } from 'react-intl';
import { DocumentType } from '../../../../enums/document-type';

const messages = defineMessages({
  affectsAllUsersWarning: {
    description: 'Print settings document options affects all users warning',
    defaultMessage: 'Adjusting any of the following options affects all users on your account.',
    id: 'E2CLym',
  },
  saveChanges: {
    description: 'select a label modal save settings button',
    defaultMessage: 'Save Settings',
    id: 'WA400E',
  },
  saveSettingsErrorMessage: {
    description: 'Save printing setup changes error message',
    defaultMessage: 'There was an error saving your printing setup. Please try again.',
    id: 'dUzEt5',
  },
  preview: {
    description: 'label print settings preview button',
    defaultMessage: 'Preview',
    id: 'ji8k27',
  },
  [DocumentType.OrderSummary.identifier]: {
    description: 'order summary print settings modal title',
    defaultMessage: 'Order Summary Printing Setup',
    id: 'ASt4iL',
  },
  [DocumentType.PickList.identifier]: {
    description: 'Pick List printing setup modal title',
    defaultMessage: 'Pick List Printing Setup',
    id: '6LiFos',
  },
  [DocumentType.PackingSlip.identifier]: {
    description: 'Packing Slip printing setup modal title',
    defaultMessage: 'Packing Slip Printing Setup',
    id: 'TksUHj',
  },
  [DocumentType.ShipmentManifest.identifier]: {
    description: 'Shipment manifest printing setup modal title',
    defaultMessage: 'Shipment Manifest Printing Setup',
    id: 'rIn6Bj',
  },
  [DocumentType.Label.identifier]: {
    description: 'select a label layout modal title',
    defaultMessage: 'Select a Label Layout',
    id: 'w10InG',
  },
});

export default messages;
